// extracted by mini-css-extract-plugin
export default {"strip":"ReservationStrip_strip__sbkUT","content":"ReservationStrip_content__DYE20","reserveBtn":"ReservationStrip_reserveBtn__jJPB2"};